export enum ENewsletterTriggerOption {
    OPEN_WEBSITE = "OPEN_WEBSITE",
    CLOSE_WEBSITE = "CLOSE_WEBSITE",
    SCROLL_TO_UP = "SCROLL_TO_UP",
    INACTIVITY = "INACTIVITY",
    URL = "URL",
}

export interface INewsletterFormAnswer {
    field: string;
    answer: string;
}

export interface INewsletterFormMetadata {
    title: string;
    subtitle: string;
    newsletterBannerLabel: string;
    emailLabel: string;
    fullNameLabel: string;
    ageLabel: string;
    phoneNumberLabel: string;
    marketingPermissionsLabel: string;
    privacyConsentLabel: string;
    coverImage: string;
    fields: {
        field: string;
        isRequired: boolean;
    }[];
    trigger: {
        type: ENewsletterTriggerOption;
        timer?: number;
        urls: {
            path: string;
            timer: number;
        }[];
    };
}
